import { encryptCryptexTransport } from '@lep-shared/cryptexEncryption';
import { aleEncryptMop } from '@lep-shared/mopEncryption';
import { sendApiRequest } from '../services/sendApiRequest';

type ProvisionAleSessionResponse = {
  keyProvResponse: string;
};

const parseKeyProvResponse = (keyProvResponseJson: string): { token?: string } => {
  try {
    return JSON.parse(keyProvResponseJson) as { token?: string };
  } catch {
    throw new Error('ALE key provisioning returned invalid JSON');
  }
};

export async function provisionAleSessionViaApi(keyProvRequestJson: string): Promise<string> {
  const response = await sendApiRequest<ProvisionAleSessionResponse, { keyProvisionReq: string }>(
    '/provision-ale-session',
    { keyProvisionReq: keyProvRequestJson },
  );

  if ('status' in response) {
    throw new Error(response.message || 'ALE key provisioning failed');
  }

  const keyProvResponseJson = response.keyProvResponse;
  const parsed = parseKeyProvResponse(keyProvResponseJson);
  if (!parsed.token) {
    throw new Error('ALE key provisioning returned no session token');
  }

  return keyProvResponseJson;
}

/** ALE-encrypts a MOP value for the `encryptedMop` field (replaces client-side KGB). */
export const encryptAleMop = async (mopValue: string, mopType: string) =>
  aleEncryptMop(mopValue, mopType, provisionAleSessionViaApi);

/** Cryptex transport encryption for the `mop` field in transit to Sharkey. */
export const encryptCryptexMop = encryptCryptexTransport;
